import { render, staticRenderFns } from "./indexAdmin.vue?vue&type=template&id=56465753&"
import script from "./indexAdmin.vue?vue&type=script&lang=js&"
export * from "./indexAdmin.vue?vue&type=script&lang=js&"
import style0 from "./indexAdmin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports